module.exports = __webpack_public_path__ + "img/66600.7654e7e6.jpg";